import Instance from '../../../utils/Axios';

const ObrasComRecursos =
  (estadosProjetoPreSelectedId, estadosSubProjetoPreSelectedId) => async (dispatch) => {
    const stateToken = localStorage.token;

    const estadosProjetosId = estadosProjetoPreSelectedId;
    const estadosSubProjetosId = estadosSubProjetoPreSelectedId;

    if (stateToken) {
      await Instance()
        .get('/obras/registarTempos', {
          params: {
            estadosProjetosId,
            estadosSubProjetosId,
          },
        })
        .then(({ data }) => {
          if (stateToken) {
            dispatch({ type: 'GET_OBRAS_COM_RECURSOS', payload: data.yData });
          }
        })
        .catch(({ err }) => console.log(err));
    }
  };

export default ObrasComRecursos;
